import { constants, mediaQueryStyles } from "@newsela/angelou";

const { ui } = constants.colors;
const { mediaQuery: breakpoint } = mediaQueryStyles;

export const containerCss = {
  display: "flex",
  flexDirection: "column",
  backgroundColor: ui.neutral[25],
  borderRadius: 4,
  padding: "15px 20px",
};

export const checkboxCss = {
  root: {
    padding: 0,
    outlineOffset: 3,
  },
};

export const detailsContainerCss = {
  display: "flex",
  gap: 20,
  marginTop: 25,
  [breakpoint.upTo(constants.breakpoints.BreakpointNames.sm)]: {
    flexDirection: "column",
  },
};

export const comboboxCss = {
  width: "100%",
  minWidth: 100,
  ul: {
    zIndex: 1,
    maxWidth: "100%",
    minWidth: 200,
    width: "100%",
    textAlign: "left",
    left: 0,
    marginTop: 26,
  },
};
